// extracted by mini-css-extract-plugin
module.exports = {"navbar":"TenantManagement_navbar__37F4l","navbarFontStyle":"TenantManagement_navbarFontStyle__3vzAL","navbarSelectedItemStyle":"TenantManagement_navbarSelectedItemStyle__2knbh"};